/**
 * The NewMatchDetailHome class acts as the view object for the new match detail home page.
 */
const Address = require('@/tbs/model/mo/Address')
const NewMatchDetail = require('@/tbs/model/to/NewMatchDetail')
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')

const locale = new NewMatchDetail
const tbs_model_vo_NewMatchDetailHome = function () {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_NewMatchDetailHome.prototype = {
  /* The view object name */
  name: '',
  /* The view object instance */
  view: {
    get: [
      {
        name: '',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          sportType: 'sportType',
          preview: '(0)'
        },
        basePath: 'data.match',
        rule: {
          componentList: '$sportType,regBeginDate,regEndDate'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatchRankResult',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          ScoreAnnouncement: '$matchList'
        }
      },
      // 近期比赛：接口返回 data.list，经 renderRecentGames 后写入 componentData.RecentGames
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatchRecentGameList',
        query: {
          unionMatchId: 'unionMatchId',
          pageSize: '(4)'
        },
        basePath: 'data',
        rule: {
          RecentGames: '$list'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMMatchList2',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          MatchGroup: '$list'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetCrmNewsList',
        query: {
          unionMatchId: 'unionMatchId',
          accountId: '^0.data.payload.data.match.accountId',  // use the object path for the variable value
          pageSize: '(4)'
        },
        basePath: 'data',
        rule: {
          NewsAnnouncement: '$list'
        },
        seq: true,    // use the seq flag with true for the flow request
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data',
        rule: {
          BasicInfo: '$match'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data',
        rule: {
          Regulations: '$match'
        }
      },
      {
        name: 'componentData',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMMatchList2',
        query: {
          unionMatchId: 'unionMatchId'
        },
        basePath: 'data',
        rule: {
          Registration: '$list'
        }
      }
    ],
  },
  //--------------------------------------------------
  // render methods
  //--------------------------------------------------
  /**
   * 根据运动类型生成组件配置列表
   * @param {String} sportType - 运动类型
   * @returns {Array} 组件配置列表
   */
  renderComponentList: function (sportType, regBeginDate, regEndDate) {
    if (!sportType) {
      return []
    }

    // 根据不同运动类型返回不同的组件配置
    const componentConfigs = {
      // '足球': this.getFootballComponents(),
      // '篮球': this.getBasketballComponents(),
      // 可以继续添加其他运动类型
    }

    // 如果找到对应运动类型的配置，返回它；否则返回默认配置
    return componentConfigs[sportType] || this.getDefaultComponents(regBeginDate, regEndDate)
  },

  /**
   * 默认组件配置（当运动类型未匹配时使用）
   */
  getDefaultComponents: function (regBeginDate, regEndDate) {
    const registration = {
      name: locale.localeProp('registration'),
      id: 'registration',
      component: 'Registration',
      emptyDataShow: false
    }
    const regulationsItem = {
      name: locale.localeProp('regulations'),
      id: 'regulations',
      component: 'Regulations',
      emptyDataShow: false
    }
    const baseItems = [
      {
        name: locale.localeProp('score-announcement'),
        id: 'score-announcement',
        component: 'ScoreAnnouncement',
        emptyDataShow: false
      },
      {
        name: locale.localeProp('recent-games'),
        id: 'recent-games',
        component: 'RecentGames',
        emptyDataShow: false
      },
      {
        name: locale.localeProp('match-group'),
        id: 'match-group',
        component: 'MatchGroup',
        emptyDataShow: false
      },
      {
        name: locale.localeProp('news-announcement'),
        id: 'news-announcement',
        component: 'NewsAnnouncement',
        emptyDataShow: false
      },
      {
        name: locale.localeProp('basic-info'),
        id: 'basic-info',
        component: 'BasicInfo',
        emptyDataShow: false
      }
    ]
    // 无报名时间则不展示赛事报名
    if (!regBeginDate || !regEndDate) {
      return baseItems.concat(regulationsItem)
    }
    // 报名中：regBeginDate <= 当前时间 <= regEndDate
    const isRegistrationOpen = (function () {
      const now = Date.now()
      const begin = new Date(regBeginDate).getTime()
      const end = new Date(regEndDate).getTime()
      if (isNaN(begin) || isNaN(end)) return false
      return now >= begin && now <= end
    })()
    if (isRegistrationOpen) {
      return [registration].concat(baseItems, regulationsItem)
    }
    return baseItems.concat(registration, regulationsItem)
  },
  /**
   * 成绩公告：将 matchList 处理成一维数组
   * 单组别：取该组按 finalRank 排序的前三；多组别：取每组第一名
   */
  renderScoreAnnouncement: function (matchList) {
    if (!matchList || !Array.isArray(matchList)) return []
    var list = (Array.isArray(matchList[0]) && matchList[0].length > 0) ? [].concat.apply([], matchList) : matchList
    var toItem = function (match, t) {
      return {
        chineseName: match.chineseName || '',
        group: match.group || '',
        id: match.id || '',
        badge: t.badge,
        finalRank: t.finalRank,
        teamId: t.id,
        matchId: t.matchId,
        name: t.name,
        loseRound: t.loseRound,
        tieRound: t.tieRound,
        winRound: t.winRound
      }
    }
    return list.reduce(function (acc, match) {
      if (!match || !Array.isArray(match.teams)) return acc
      var teams = match.teams.slice().sort(function (a, b) {
        return (a.finalRank != null ? Number(a.finalRank) : 999) - (b.finalRank != null ? Number(b.finalRank) : 999)
      })
      var take = list.length === 1 ? teams.slice(0, 3) : teams.slice(0, 1)
      take.forEach(function (t) { acc.push(toItem(match, t)) })
      return acc
    }, [])
  },
  /**
   * 格式化近期比赛列表，供 componentData.RecentGames 使用
   * 规则 RecentGames: '$list' 会传入 data.list 并调用本方法
   */
  renderRecentGames: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    const self = this
    return list.map(function (item) {
      return self.formatRecentGameItem(item)
    })
  },

  formatRecentGameItem: function (item) {
    if (!item) return {}
    return {
      id: item.id,
      name: item.name || item.roundName,
      home: {
        name: item.homeAlias || item.homeName || locale.localeProp('team-name-default'),
        logUrl: item.homeBadge || locale.localeProp('team-logo-default'),
        homeTeamId: item.homeTeamId || '',
        score: item.homeScore == -1 ? '' : item.homeScore,
      },
      away: {
        name: item.awayAlias || item.awayName || locale.localeProp('team-name-default'),
        logUrl: item.awayBadge || locale.localeProp('team-logo-default'),
        awayTeamId: item.awayTeamId || '',
        score: item.awayScore == -1 ? '' : item.awayScore,
      },
      time: item.beginDate ? DateTimeFunc.formatDate(new Date(item.beginDate), 'MM.dd hh:mm') : '',
      status: this.renderStatus(item.liveRoomStatus, item.liveStatus),
      statusLabel: this.renderStatusLabel(item.liveStatus),
    }
  },
  renderStatus: function (liveRoomStatus, liveStatus) {
    if (liveRoomStatus === -1) { // 未开通直播
      return -1
    } else return liveStatus // 0未直播 1直播中 2回看
  },
  renderStatusLabel: function (liveStatus) {
    if (liveStatus === -1) {
      return ''
    } else return locale.localeProp('live-status-label-' + liveStatus)
  },
  renderMatchGroup: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    return list.map(item => {
      return {
        id: item.id,
        name: item.group
      }
    })
  },
  renderNewsAnnouncement: function (list) {
    if (!list || !Array.isArray(list)) {
      return []
    }
    return list.map(item => {
      return {
        id: item.id,
        title: item.title,
        sourceUrl: item.sourceUrl || '',
        publishDate: DateTimeFunc.formatDate(new Date(item.publishDate), 'MM/dd') || '',
      }
    })
  },
  renderBasicInfo: function (match) {
    if (!match) return {}
    return {
      id: match.id,
      beginDate: DateTimeFunc.formatDate(new Date(match.beginDate), 'yyyy-MM-dd') || '',
      endDate: DateTimeFunc.formatDate(new Date(match.endDate), 'yyyy-MM-dd') || '',
      city: Address.renderAddress(match.province, match.city, match.district, '') || '',
      location: match.location || '',
      units: this.renderUnits(match.supervisor, match.endorser, match.contactor, match.coorganizer) || '',
      regBeginDate: match.regBeginDate || '',
      regEndDate: match.regEndDate || '',
    }
  },
  renderUnits: function (supervisor, endorser, contactor, coorganizer) {
    const units = []
    if (supervisor) {
      units.push({
        name: locale.localeProp('supervisor'),
        value: supervisor.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (endorser) {
      units.push({
        name: locale.localeProp('endorser'),
        value: endorser.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (contactor) {
      units.push({
        name: locale.localeProp('contactor'),
        value: contactor.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    if (coorganizer) {
      units.push({
        name: locale.localeProp('coorganizer'),
        value: coorganizer.replace(/｜/g, '|').replace(/,/g, '、'),
      })
    }
    return units
  },
  renderRegulations: function (match) {
    if (!match) return {}
    return match.regulations || ''
  },
  renderRegistration: function (list, options, transformedCollection) {
    // try to use the appendix parameters for the extended data source
    // use the options for the current context one
    // use the transformedCollection for the whole caller one
    if (!list || !Array.isArray(list)) {
      return { groupsName: '', price: '' }
    }
    const groupsName = list.map(function (item) { return item.group }).join('、')
    const price = this._formatRegistrationPrice(list)
    // transformedCollection 中寻找 BasicInfo, 获取regBeginDate和regEndDate
    let regBeginDate = ''
    let regEndDate = ''
    let unionMatchId = ''
    transformedCollection.forEach(item => {
      if (item['BasicInfo']) {
        regBeginDate = item['BasicInfo'].regBeginDate
        regEndDate = item['BasicInfo'].regEndDate
        unionMatchId = item['BasicInfo'].id
      }
    })
    return {
      groupsName,
      price,
      regBeginDate,
      regEndDate,
      unionMatchId
    }
  },
  /**
   * 计算报名最低价文案：0元/队 起、1元/人 起 等
   * feeMethod: 0不付费 1队员付款 2领队付款 3领队付款(按人数)
   * unitType: 0队伍 1个人 2多人
   * openFeeMin: 0关 1开；feeMinAmount: 领队按人数时的最低金额(分)
   */
  _formatRegistrationPrice: function (list) {
    if (!list || list.length === 0) return ''
    var getUnitText = function (unitType) {
      if (unitType === 0) return '队'
      if (unitType === 1) return '人'
      return '人'
    }
    var minAmount = null
    var minUnit = getUnitText(list[0] && list[0].unitType)
    var firstUnitType = list[0] && list[0].unitType
    for (var i = 0; i < list.length; i++) {
      var item = list[i]
      var feeMethod = item.feeMethod
      var unitType = item.unitType
      var amountFen = 0
      var unit = getUnitText(unitType)
      if (feeMethod === 0) {
        amountFen = 0
        unit = getUnitText(unitType)
      } else if (feeMethod === 1) {
        amountFen = item.feeAmount != null ? Number(item.feeAmount) : 0
        unit = '人'
      } else if (feeMethod === 2) {
        amountFen = item.feeAmount != null ? Number(item.feeAmount) : 0
        unit = '队'
      } else if (feeMethod === 3) {
        var openFeeMin = item.openFeeMin
        amountFen = (openFeeMin === 1 && item.feeMinAmount != null)
          ? Number(item.feeMinAmount)
          : (item.feeAmount != null ? Number(item.feeAmount) : 0)
        unit = '人'
      } else {
        amountFen = 0
        unit = getUnitText(unitType)
      }
      if (minAmount === null || amountFen < minAmount) {
        minAmount = amountFen
        minUnit = unit
      }
    }
    if (minAmount === null) {
      minAmount = 0
      minUnit = firstUnitType !== undefined ? getUnitText(firstUnitType) : '人'
    }
    var yuan = (minAmount / 100).toFixed(0)
    return yuan + '元/' + minUnit + ' 起'
  }
}

module.exports = tbs_model_vo_NewMatchDetailHome
